export default __webpack_public_path__ + "static/media/Training.d88f89ad.jpg";